<main role="main">
    <div class="jumbotron banner-image">
        <div class="container-fluid">
            <div class="d-flex flex-row align-items-center banner-logo justify-content-between">
                <div class="d-none d-sm-block">
                    <a href="/"><img class="image-logo" src="../assets/images/gevernova_logo.svg"></a>
                </div>
                <div class="d-none d-sm-block">
                    <a href="/login?redirectTo=HYDRO" *ngIf="!userName"><button class="btn-login"
                            style="white-space: nowrap;">SIGN IN</button></a>
                    <div *ngIf="userName" class="text-white btn-login w-auto d-sm-none d-md-block"
                        style="padding:8px 12px;">
                        <div class="d-flex flex-row align-items-center ">
                            <a href="/" class="d-flex flex-row justify-content-center">
                                <mat-icon class="text-white mr-2">home</mat-icon>
                            </a>
                            <a [routerLink]="['/application-catalog']" [queryParams]="{selectedIndexTab: 1}"
                                target="_blank" class="text-white">{{userName}}&nbsp; &nbsp;({{roleName.toUpperCase()}})</a>
                            <mat-icon (click)="logOut()" class="text-white ml-2" style="cursor: pointer">input
                            </mat-icon>
                        </div>
                    </div>
                </div>
                <div class="d-sm-none d-xl-none">
                    <a href="/"><img class="image-logo" src="../assets/images/logo-ge-mobile.png"></a>
                </div>
                <div class="d-sm-none d-xl-none">
                    <div *ngIf="!userName">
                        <a href="/login?redirectTo=HYDRO">
                            <button class="btn-login" style="
                        padding:8px 12px !important; width: auto;"><img style="height: 30px;"
                                    src="../assets/images/account-circle.png"></button>
                        </a>
                    </div>
                </div>
            </div>
            <div class="d-md-none d-xl-none" *ngIf="userName">
                <div class="text-white btn-login w-auto d-flex flex-row justify-content-between align-items-center"
                    style="padding:8px; border-radius: 0px 0px 4px 4px;">
                    <div class="d-flex flex-row align-items-center">
                        <a href="/" class="d-flex flex-row justify-content-center">
                            <mat-icon class="text-white ml-3 mr-2">home</mat-icon>
                        </a>
                        <a [routerLink]="['/application-catalog']" [queryParams]="{selectedIndexTab: 1}" target="_blank"
                            class="text-white">{{userName}}&nbsp; &nbsp;({{roleName}})</a>
                    </div>
                    <div class="d-flex flex-row align-items-center text-white" (click)="logOut()"
                        style="cursor: pointer">
                        <mat-icon class="text-white mr-2">input</mat-icon>
                        <div>Sign Out</div>
                    </div>
                </div>

            </div>
            <div class="header-text-title mt-3">Hydro Power Supplier Collaboration Portal</div>
            <div class="header-text-des w-100 w-md-75 w-xl-50 mt-1">At GE Vernova, we recognize that our suppliers are critical partners, 
                and play a vital role in the creation of our world-class solutions. We are happy to provide all of our suppliers with tools and services to make you more efficient, knowledgeable, and above all, help to sustain a close, productive relationship with GE Vernova.</div>
            <div class="header-text-footer w-100 w-md-75 w-xl-50 mt-2">A GE Single Sign-On ID (SSO) is required to access all GE Vernova resources.</div>
            <p class="mt-2" *ngIf="!userName"><a class="btn btn-primary btn-lg btn-register" style="border-color: #005E60 !important;" (click)="goPageRegister()"
                    role="button">Request GE SSO</a></p>
        </div>
    </div>

    <div class="container-fluid" style="padding-bottom:150px;">
        <!-- Example row of columns -->
        <div class="row">
            <div class="col-md-12 col-xl-6 col-sm-12 mt-3">
                <div class="d-flex flex-row">
                    <div style="width: 100%;">
                        <div class="d-flex flex-row" style="
                            width: 100%;
                            padding-bottom: 30px;
                            border-left: 1px solid #005E60;
                            border-bottom-left-radius: 4px;
                            border-bottom: 1px solid #005E60;">
                            <div style="
                                width: 16px;
                                height: 16px;
                                background-color: #005E60;
                                border-radius: 50%;
                                margin-left: -8px;">
                            </div>
                            <div style="color:#005E60;font-weight: 700;
                            font-size: 20px;margin-top: -6px;
                            margin-left: 10px;">Before Order Placement</div>
                        </div>
                        <div class="d-flex flex-row justify-content-around">
                            <div class="d-flex flex-column justifi-content-center align-items-center col">
                                <div style="
                                    width: 16px;
                                    height: 16px;
                                    background-color: #005E60;
                                    border-radius: 50%;
                                    margin-top: -8px;">
                                </div>
                                <div style="color:#005E60;font-weight: 700;
                                font-size: 14px;text-align: center;"> Registration </div>
                            </div>
                            <div class="d-flex flex-column justifi-content-center align-items-center col">
                                <div style="
                                    width: 16px;
                                    height: 16px;
                                    background-color: #005E60;
                                    border-radius: 50%;
                                    margin-top: -8px;">
                                </div>
                                <div style="color:#005E60;font-weight: 700;
                                font-size: 14px;text-align: center;"> Quotations </div>
                            </div>
                            <div class="d-flex flex-column justifi-content-center align-items-center col">
                                <div style="
                                    width: 16px;
                                    height: 16px;
                                    background-color: #005E60;
                                    border-radius: 50%;
                                    margin-top: -8px;">
                                </div>
                                <div style="color:#005E60;font-weight: 700;
                                font-size: 14px;text-align: center;"> Engineering </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top:30px;">
                    <div class="mb-1 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div class="card">
                            <a href="https://www.gesupplierconnect.com/sc/home" target="_blank">
                                <div class="card-img-logo d-flex flex-row justify-content-center align-items-center">
                                    <img class="card-img-top card-img-logo-child"
                                        src="../assets/images/supplier-connect.png" alt="Card image cap">
                                </div>
                            </a>
                            <div class="card-body card-body-logo d-flex flex-column justify-content-between">
                                <div>
                                    <div
                                        class="card-title mb-0 d-flex flex-row align-items-center justify-content-between">
                                        <span class="card-title-logo">Supplier Connect</span>
                                        <a *ngIf="userName" [routerLink]="['/application-training-document']"
                                            target="_blank"><span class="card-title-guide" matTooltip="Login Required"
                                                [matTooltipPosition]="'above'" style="cursor: pointer;">Guide</span></a>
                                        <a *ngIf="!userName" href="/login?redirectTo=APPLICATION_TRANING_DOCUMENT"
                                            target="_blank"><span class="card-title-guide" matTooltip="Login Required"
                                                [matTooltipPosition]="'above'" style="cursor: pointer;">Guide</span></a>
                                    </div>
                                    <p class="card-text card-text-logo">Self-management of business data</p>

                                </div>
                                <div class="d-flex pt-1 flex-row align-items-center justify-content-between">
                                    <a class="btn btn-logo-disabled w-50 h-100 justify-content-center">Invite
                                        only</a>
                                    <div style="width: 10px;"></div>
                                    <a href="https://www.gesupplierconnect.com/sc/home" target="_blank"
                                        class="btn btn-go-to-app w-50 h-100 justify-content-center">Go to
                                        app</a>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="mb-1 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div class="card">
                            <a href="https://oscar.ren.apps.ge.com/" target="_blank">
                                <div class="card-img-logo d-flex flex-row justify-content-center align-items-center">
                                    <img class="card-img-top card-img-logo-child" src="../assets/images/oscar.png"
                                        alt="Card image cap">
                                </div>
                            </a>
                            <div class="card-body card-body-logo d-flex flex-column justify-content-between">
                                <div>
                                    <div
                                        class="card-title mb-0 d-flex flex-row align-items-center justify-content-between">
                                        <span class="card-title-logo">Oscar</span>
                                        <a *ngIf="userName" [routerLink]="['/application-training-document']"
                                            target="_blank"><span class="card-title-guide" matTooltip="Login Required"
                                                [matTooltipPosition]="'above'" style="cursor: pointer;">Guide</span></a>
                                        <a *ngIf="!userName" href="/login?redirectTo=APPLICATION_TRANING_DOCUMENT"
                                            target="_blank"><span class="card-title-guide" matTooltip="Login Required"
                                                [matTooltipPosition]="'above'" style="cursor: pointer;">Guide</span></a>
                                    </div>
                                    <p class="card-text card-text-logo">Respond to requests for quotations</p>

                                </div>
                                <div class="d-flex pt-1 flex-row align-items-center justify-content-between">
                                    <a class="btn btn-logo-disabled w-50 h-100 justify-content-center">Invite
                                        only</a>
                                    <div style="width: 10px;"></div>
                                    <a href="https://oscar.ren.apps.ge.com/" target="_blank"
                                        class="btn btn-go-to-app w-50 h-100 justify-content-center">Go to
                                        app</a>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="mb-1 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div class="card">
                            <a href="https://corella.ren.apps.ge.com/innovator" target="_blank">
                                <div class="card-img-logo d-flex flex-row justify-content-center align-items-center">
                                    <img class="card-img-top card-img-logo-child" src="../assets/images/corella.png"
                                        alt="Card image cap">
                                </div>
                            </a>
                            <div class="card-body card-body-logo d-flex flex-column justify-content-between">
                                <div>
                                    <div
                                        class="card-title mb-0 d-flex flex-row align-items-center justify-content-between">
                                        <span class="card-title-logo">Collaboration Spaces</span>
                                        <a *ngIf="userName" [routerLink]="['/application-training-document']"
                                            target="_blank"><span class="card-title-guide" matTooltip="Login Required"
                                                [matTooltipPosition]="'above'" style="cursor: pointer;">Guide</span></a>
                                        <a *ngIf="!userName" href="/login?redirectTo=APPLICATION_TRANING_DOCUMENT"
                                            target="_blank"><span class="card-title-guide" matTooltip="Login Required"
                                                [matTooltipPosition]="'above'" style="cursor: pointer;">Guide</span></a>
                                    </div>
                                    <p class="card-text card-text-logo">Access up-to-date technical documentations</p>
                                </div>
                                <div class="d-flex pt-1 flex-row align-items-center justify-content-between">
                                    <a class="btn btn-logo-disabled w-50 h-100 justify-content-center">Invite
                                        only</a>
                                    <div style="width: 10px;"></div>
                                    <a href="https://corella.ren.apps.ge.com/innovator" target="_blank"
                                        class="btn btn-go-to-app w-50 h-100 justify-content-center">Go to
                                        app</a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12 col-xl-6 col-sm-12 mt-3">
                <div class="d-flex flex-row">
                    <div style="width: 100%;">
                        <div class="d-flex flex-row" style="
                            width: 100%;
                            padding-bottom: 30px;
                            border-left: 1px solid #005E60;
                            border-bottom-left-radius: 4px;
                            border-bottom: 1px solid #005E60;">
                            <div style="
                                width: 16px;
                                height: 16px;
                                background-color: #005E60;
                                border-radius: 50%;
                                margin-left: -8px;">
                            </div>
                            <div style="color:#005E60;font-weight: 700;
                            font-size: 20px;margin-top: -6px;
                            margin-left: 10px;">Order Execution</div>
                        </div>
                        <div class="d-flex flex-row justify-content-around">
                            <div class="d-flex flex-column justifi-content-center align-items-center col">
                                <div style="
                                    width: 16px;
                                    height: 16px;
                                    background-color: #005E60;
                                    border-radius: 50%;
                                    margin-top: -8px;">
                                </div>
                                <div style="color:#005E60;font-weight: 700;
                                font-size: 14px;text-align: center;"> Quality </div>
                            </div>
                            <div class="d-flex flex-column justifi-content-center align-items-center col">
                                <div style="
                                    width: 16px;
                                    height: 16px;
                                    background-color: #005E60;
                                    border-radius: 50%;
                                    margin-top: -8px;">
                                </div>
                                <div style="color:#005E60;font-weight: 700;
                                font-size: 14px;text-align: center;"> Delivery </div>
                            </div>
                            <div class="d-flex flex-column justifi-content-center align-items-center col">
                                <div style="
                                    width: 16px;
                                    height: 16px;
                                    background-color: #005E60;
                                    border-radius: 50%;
                                    margin-top: -8px;">
                                </div>
                                <div style="color:#005E60;font-weight: 700;
                                font-size: 14px;text-align: center;"> PO collaboration & invoicing </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top:30px;">
                    <div class="mb-1 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div class="card">
                            <a href="https://qs.ren.apps.ge.com/sdh" target="_blank">
                                <div class="card-img-logo d-flex flex-row justify-content-center align-items-center">
                                    <img class="card-img-top card-img-logo-child"
                                        src="../assets/images/quaility-suite.png" alt="Card image cap">
                                </div>
                            </a>
                            <div class="card-body card-body-logo d-flex flex-column justify-content-between">
                                <div>
                                    <div
                                        class="card-title mb-0 d-flex flex-row align-items-center justify-content-between">
                                        <span class="card-title-logo">Quality Suite</span>
                                        <a *ngIf="userName" [routerLink]="['/application-training-document']"
                                            target="_blank"><span class="card-title-guide" matTooltip="Login Required"
                                                [matTooltipPosition]="'above'" style="cursor: pointer;">Guide</span></a>
                                        <a *ngIf="!userName" href="/login?redirectTo=APPLICATION_TRANING_DOCUMENT"
                                            target="_blank"><span class="card-title-guide" matTooltip="Login Required"
                                                [matTooltipPosition]="'above'" style="cursor: pointer;">Guide</span></a>
                                    </div>
                                    <p class="card-text card-text-logo">Supplier Deviation Requests (SDR) & Requests for Information (RFI)</p>
                                </div>
                                <div class="d-flex pt-1 flex-row align-items-center justify-content-between">
                                    <a *ngIf="userName" [routerLink]="['/application-catalog']"
                                        [queryParams]="{item: 'Quality Suite'}" target="_blank"
                                        class="btn btn-registration w-50 h-100 justify-content-center">Registration</a>
                                    <a *ngIf="!userName" href="/login?redirectTo=APPLICATiON_CATALOG_QUAILITY_SUITE" target="_blank"
                                        class="btn btn-registration w-50 h-100 justify-content-center">Registration</a>
                                    <div style="width: 10px;"></div>
                                    <a href="https://qs.ren.apps.ge.com/sdh" target="_blank"
                                        class="btn btn-go-to-app w-50 h-100 justify-content-center">Go to
                                        app</a>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="mb-1 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div class="card">
                            <a href="https://mta-portal.gepower.com/supefu/" target="_blank">
                                <div class="card-img-logo d-flex flex-row justify-content-center align-items-center">
                                    <img class="card-img-top card-img-logo-child" src="../assets/images/mta.png"
                                        alt="Card image cap">
                                </div>
                            </a>
                            <div class="card-body card-body-logo d-flex flex-column justify-content-between">
                                <div>
                                    <div
                                        class="card-title mb-0 d-flex flex-row align-items-center justify-content-between">
                                        <span class="card-title-logo">MTA</span>
                                        <a *ngIf="userName" [routerLink]="['/application-training-document']"
                                            target="_blank"><span class="card-title-guide" matTooltip="Login Required"
                                                [matTooltipPosition]="'above'" style="cursor: pointer;">Guide</span></a>
                                        <a *ngIf="!userName" href="/login?redirectTo=APPLICATION_TRANING_DOCUMENT"
                                            target="_blank"><span class="card-title-guide" matTooltip="Login Required"
                                                [matTooltipPosition]="'above'" style="cursor: pointer;">Guide</span></a>
                                    </div>
                                    <p class="card-text card-text-logo">Manufacturing plans, packing lists & quality
                                        inspection
                                    </p>
                                </div>
                                <div class="d-flex pt-1 flex-row align-items-center justify-content-between">
                                    <a class="btn btn-logo-disabled w-50 h-100 justify-content-center">Invite
                                        only</a>
                                    <div style="width: 10px;"></div>
                                    <a href="https://mta-portal.gepower.com/supefu/" target="_blank"
                                        class="btn btn-go-to-app w-50 h-100 justify-content-center">Go to
                                        app</a>
                                </div>

                            </div>
                        </div>
                        <div class="card mt-sm-3 mt-1">
                            <div class="card-img-logo d-flex flex-row justify-content-center align-items-center">
                                <img class="card-img-top card-img-logo-child" src="../assets/images/neo.png"
                                    alt="Card image cap">
                            </div>
                            <div class="card-body card-body-logo d-flex flex-column justify-content-between">
                                <div>
                                    <div
                                        class="card-title mb-0 d-flex flex-row align-items-center justify-content-between">
                                        <span class="card-title-logo">NEO</span>
                                        <a *ngIf="userName" [routerLink]="['/application-training-document']"
                                            target="_blank"><span class="card-title-guide" matTooltip="Login Required"
                                                [matTooltipPosition]="'above'" style="cursor: pointer;">Guide</span></a>
                                        <a *ngIf="!userName" href="/login?redirectTo=APPLICATION_TRANING_DOCUMENT"
                                            target="_blank"><span class="card-title-guide" matTooltip="Login Required"
                                                [matTooltipPosition]="'above'" style="cursor: pointer;">Guide</span></a>
                                    </div>
                                    <p class="card-text card-text-logo">Recording of forecasted delivery dates for simple POs via email</p>
                                </div>
                                <div class="d-flex pt-1 flex-row align-items-center justify-content-between">
                                    <a class="btn btn-logo-disabled w-50 h-100 justify-content-center">Invite
                                        only</a>
                                    <div style="width: 10px;"></div>
                                    <a class="btn btn-logo-disabled w-50 h-100 justify-content-center">No link</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-1 col-lg-4 col-md-4 col-sm-4 col-xs-12">
                        <div class="card">
                            <a href="https://service.ariba.com/Supplier.aw/125006063/aw?awh=r&awssk=YKkVvv_L&dard=1" target="_blank">
                                <div class="card-img-logo d-flex flex-row justify-content-center align-items-center">
                                    <img class="card-img-top card-img-logo-child" src="../assets/images/sap-ariba.png"
                                        alt="Card image cap">
                                </div>
                            </a>
                            <div class="card-body card-body-logo d-flex flex-column justify-content-between">
                                <div>
                                    <span class="note-title">North America only</span>
                                    <div
                                        class="card-title mb-0 d-flex flex-row align-items-center justify-content-between">
                                        <span class="card-title-logo">Ariba</span>
                                        <a *ngIf="userName" [routerLink]="['/application-training-document']"
                                            target="_blank"><span class="card-title-guide" matTooltip="Login Required"
                                                [matTooltipPosition]="'above'" style="cursor: pointer;">Guide</span></a>
                                        <a *ngIf="!userName" href="/login?redirectTo=APPLICATION_TRANING_DOCUMENT"
                                            target="_blank"><span class="card-title-guide" matTooltip="Login Required"
                                                [matTooltipPosition]="'above'" style="cursor: pointer;">Guide</span></a>
                                    </div>
                                    <p class="card-text card-text-logo">PO acknowledgement/ updating & electronic
                                        invoicing</p>
                                </div>
                                <div class="d-flex pt-1 flex-row align-items-center justify-content-between">
                                    <a class="btn btn-logo-disabled w-50 h-100 justify-content-center">Invite
                                        only</a>
                                    <div style="width: 10px;"></div>
                                    <a href="https://service.ariba.com/Supplier.aw/125006063/aw?awh=r&awssk=YKkVvv_L&dard=1" target="_blank"
                                        class="btn btn-go-to-app w-50 h-100 justify-content-center">Go to
                                        app</a>
                                </div>

                            </div>
                        </div>
                        <div class="card mt-sm-3 mt-1">
                            <a href="https://gecorp.custhelp.com/app/utils/login_custom/redirect/S2PSupplierSupport%2Fcustomer_inquiry" target="_blank">
                                <div class="card-img-logo d-flex flex-row justify-content-center align-items-center">
                                    <img class="card-img-top card-img-logo-child" src="../assets/images/ge-supplier-support.jpg"
                                        alt="Card image cap">
                                </div>
                            </a>
                            <div class="card-body card-body-logo d-flex flex-column justify-content-between">
                                <div>
                                    <div
                                        class="card-title mb-0 d-flex flex-row align-items-center justify-content-between">
                                        <span class="card-title-logo">S2P Help</span>
                                    </div>
                                    <p class="card-text card-text-logo">Check invoice payment status</p>
                                </div>
                                <div class="d-flex pt-1 flex-row align-items-center justify-content-between">
                                    <a class="btn btn-logo-disabled w-50 h-100 justify-content-center">Free access</a>
                                    <div style="width: 10px;"></div>
                                    <a href="https://gecorp.custhelp.com/app/utils/login_custom/redirect/S2PSupplierSupport%2Fcustomer_inquiry" target="_blank"
                                        class="btn btn-go-to-app w-50 h-100 justify-content-center">Go to
                                        app</a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div> <!-- /container-fluid -->

</main>